import React from 'react';
import {motion} from 'framer-motion';

const Footer = () => {
  return (
    <motion.footer 
      initial={{opacity: 0}} 
      whileInView={{opacity: 1}} 
      viewport={{once: true}} 
      transition={{duration: 0.8, delay: 0.2}} 
      className="w-full py-8 mt-12 glass-effect border-t border-white/5" 
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center justify-center text-sm">
          <div className="text-gray-300 text-center">
            © 2026 <a href="https://www.ligonroadllc.com/" target="_blank" rel="noopener noreferrer" className="text-cream-400 font-semibold hover:text-cream-300 transition-colors hover:underline">Ligon Road Innovations LLC</a>. All rights reserved.
          </div>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;